import mentoriaAxios from '../axiosTokenMiddleware';

const mentoriaFinancieraURL = process.env.REACT_APP_MENTORIA_FINANCIERA_URL;
const mentoriaFinancieraApiKey =
	process.env.REACT_APP_MENTORIA_FINANCIERA_API_KEY;

export const getPrincipalResults = async () => {
	return mentoriaAxios.get(mentoriaFinancieraURL + "getDiagnosticResult", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaFinancieraApiKey,
		},
	});
};

export const getSecondaryResults = async () => {
	return mentoriaAxios.get(mentoriaFinancieraURL + "getDiagnosticResultHistorical", {
		headers: {
			"Content-Type": "application/json",
			ApiKey: mentoriaFinancieraApiKey,
		},
	});
};